<div class="row patient-appointments-root">
    <div class="col-12">
        <div class="appointments-management-container">
            <span class="sticky-area">
                <div class="appointments-mgmt-header pt-3 align-items-center">
                    <div
                        class="col-12 text-center text-sm-start d-flex align-items-center justify-content-between px-3">
                        <span class="page-header-title">Appointments <cva-manual-refresh [id]="patientId"
                                [identifier]="manualRefreshIdentifier" [additionalData]="additionalParams"
                                (dataFetched)="patchRefreshedData($event)"></cva-manual-refresh></span>
                        <button *ngIf="isDialogMode" type="button" mat-icon-button aria-label="close dialog" mat-dialog-close>
                            <mat-icon>close</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="flex-container pt-3 px-3 mb-1">
                    <div class="date-input col-md-6">
                        <mat-date-range-input [rangePicker]="picker" [formGroup]="range" [min]="currentDate.toDate()">
                            <input matStartDate formControlName="startDate" placeholder="Start date">
                            <input matEndDate formControlName="endDate" placeholder="End date"
                                (dateChange)="onDateSelect()">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker (closed)="onDatepickerClosed()"></mat-date-range-picker>
                    </div>
                    <div class="date-container">
                        <span class="date-text"><strong>{{displayDate}}</strong></span>
                    </div>
                    <div class="icon-text-container">
                        <button type="button" class="no-button" (click)="picker.open()">
                            <mat-icon class="calendar-icon" fontIcon="calendar_month"></mat-icon>
                        </button>
                        <div>
                            <button type="button" class="no-button arrow-icon"
                                [ngClass]="{disabled:isPrevArrowDisabled}"
                                (click)="!isPrevArrowDisabled ? goToPrev('week'): false"><i
                                    class="bi bi-chevron-double-left"></i></button>
                            <span class="span-title">Week</span>
                            <button type="button" class="no-button arrow-icon" (click)="goToNext('week')"><i
                                    class="bi bi-chevron-double-right"></i></button>
                        </div>
                        <div>
                            <button type="button" class="no-button arrow-icon"
                                [ngClass]="{disabled:isPrevArrowDisabled}"
                                (click)="!isPrevArrowDisabled ? goToPrev('month'):false"><i
                                    class="bi bi-chevron-double-left"></i></button>
                            <span class="span-title">Month</span>
                            <button type="button"class="no-button arrow-icon" (click)="goToNext('month')"><i
                                    class="bi bi-chevron-double-right"></i></button>
                        </div>
                    </div>
                </div>


            </span>
            <div class="appointments-list-container mt-2">

                <!-- Mobile screen -->
                <div class="d-block d-sm-none px-3 ">
                    <ng-container *ngIf="appointments && appointments.length > 0;else noRecordFound">
                        <div class="my-2" *ngFor="let appointment of appointments" aria-hidden="true">
                            <cva-appointment-card-view [appointment]="appointment"
                                (actionClick)="onActionClick($event)"></cva-appointment-card-view>
                        </div>
                    </ng-container>

                    <ng-template #noRecordFound>
                        <div class="row apt-container justify-content-center mb-4 p-4 text-grey">
                            <mat-card>
                                <mat-card-content class="text-center">
                                    <strong>No Record Found.</strong>
                                </mat-card-content>
                            </mat-card>
                        </div>
                    </ng-template>
                </div>
                <!-- Desktop Screen -->
                <div class="d-none d-sm-block px-3 ">
                    <div class="table-container">
                        <div class="table-container text-capitalize">
                            <cva-data-table [displayedColumns]="displayedColumns" [tableData]="appointments"
                                [pageSize]="10" [pageSizeOptions]="[5,10,15,20,25,30]"
                                [tableClass]="'appointments-table'" [isEditable]="false" [isDeletable]="true"
                                [isRowClickable]="false" [deleteConfirmationMessage]="deleteConfirmationMessage"
                                [skipConfirmationPopup]="true"
                                [showPagination]="appointments && appointments.length > 0"
                                (actionClick)="onActionClick($event)"></cva-data-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
